import { useEffect, useState } from "react";

import { getFiltersFromStorage } from "@/components/AgendaFilters/utils/getFiltersFromStorage";
import { HoleCount } from "@/features/TeeSheet/components/TimeSlotList/components/__generated__/TimeSlotListInternalQuery.graphql";

export const useInitializeStoredHoleCountFilter = (
  facilityId: string | null,
  setHoleCountFilter: (holeCountFilter: HoleCount) => void
) => {
  const [filterLoaded, setFilterLoaded] = useState(false);
  useEffect(() => {
    if (!facilityId || filterLoaded) {
      return;
    }
    const loadFilters = async () => {
      try {
        const storedHoleCountFilter = await getFiltersFromStorage(
          `x-whoosh-${facilityId}-hole-count-filter`
        );
        // stored items can only be of type string, so we need to convert them to the correct type
        switch (storedHoleCountFilter) {
          case "NINE":
            setHoleCountFilter("NINE");
            break;
          case "EIGHTEEN":
            setHoleCountFilter("EIGHTEEN");
            break;
          case "NONE":
            setHoleCountFilter("NONE");
            break;

          default:
            return;
        }
      } catch (error) {
        setFilterLoaded(true);
      }
    };
    loadFilters().finally(() => {
      setFilterLoaded(true);
    });
  }, [facilityId, setHoleCountFilter, filterLoaded]);
};
